import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Campaign3KontableComponent } from 'app/views/campaign-3/components/campaign-3-kontable/campaign-3-kontable.component';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/primeng';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { BreadCrumbModel } from 'app/views/campaign-3/models/campaign-3-breadcrumb.model';
import { BasketService } from '../basket.service';
import { ProductItemComplete } from '../baskets.model';
import { BasketImportDetailService } from '../basket-import-detail.service';

@Component({
  selector: 'app-basket-import-articles',
  templateUrl: './basket-import-articles.component.html',
  styleUrls: ['./basket-import-articles.component.css']
})
export class BasketImportDetailComponent implements OnInit {

  /* =======================
   * INPUT / OUTPUT
   * ======================= */
  @Input() departmentList: Array<any> = [];
  @Output() departmentListSelected: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('basketImportArticlesKontable')
  kontableComponent: Campaign3KontableComponent;

  /* =======================
   * UI CONFIG
   * ======================= */
  paginationType: number = Campaign3KontableComponent.ServerPagination;

  textFilter = KontableComponent.TextFilter;
  selectFilter = KontableComponent.SelectFilter;
  dateFilter = KontableComponent.DateFilter;
  numberFilter = KontableComponent.NumberFilter;
  noFilter = KontableComponent.NoFilter;
  showTable: boolean = false;
  showBreadCrumb: boolean = false;

  /* =======================
   * DATA
   * ======================= */
  breadcrumbs: Array<BreadCrumbModel> = [];
  basketArticles: Array<ProductItemComplete> = [];

  articleStatusList: Array<{ label: string; value: string }> = [];
  translationsMap: { [key: string]: string } = {};

  basketHeadId: string = '';
  basketId: string = '';

  /* =======================
   * CONSTRUCTOR
   * ======================= */
  constructor(
    private notifyService: MessageService,
    private translateService: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private basketImportDetailService: BasketImportDetailService,
    private basketService: BasketService
  ) {
    this.subscribeToRouteParams();
  }

  /* =======================
   * LIFECYCLE
   * ======================= */
  ngOnInit(): void {
    this.initBreadCrumbs();
    this.loadFilterList();
  }

  /* =======================
   * ROUTE
   * ======================= */
  private subscribeToRouteParams(): void {
    this.route.queryParams.subscribe(params => {
      const id = params['basketHeadId'];
      const basketId = params['basketId'];
      if (!id) {
        this.showErrorMessage('ID basket mancante nella route');
        return;
      }

      this.basketHeadId = id;
      this.basketId = basketId;

      this.basketImportDetailService.basketHeadId = id;
    });
  }

  /* =======================
   * API
   * ======================= */
  private loadBasketArticles(basketId: string): void {
    this.basketService.getArticlesFromBasket(basketId).subscribe(
      res => {
        if (!res || !res.data) {
          this.basketArticles = [];
          return;
        }

        this.basketArticles = res.data;
        this.showTable = true;
      },
      error => {
        console.error('Errore caricamento articoli basket:', error);
        this.showErrorMessage('Errore durante il caricamento degli articoli');
      }
    );
  }

  /* =======================
   * FILTERS / TRANSLATIONS
   * ======================= */
  private loadFilterList(): void {
    this.translateService.get([
      'common.active',
      'common.inactive'
    ]).subscribe(translations => {

      this.translationsMap = translations;

      this.articleStatusList = [
        { label: '', value: '' },
        { label: translations['common.active'], value: '1' },
        { label: translations['common.inactive'], value: '0' }
      ];

      this.showTable = true;
    });
  }

  translateArticleStatus(value: string): string {
    if (value === '1') {
      return this.translationsMap['common.active'] || '';
    }
    if (value === '0') {
      return this.translationsMap['common.inactive'] || '';
    }
    return '';
  }

  /* =======================
   * BREADCRUMB
   * ======================= */
  private initBreadCrumbs(): void {
    this.translateService.get([
      'breadCrumb.baskets_list',
      'breadCrumb.basketArticles'
    ]).subscribe(translations => {

      this.breadcrumbs = [
        {
          code: 'bc1',
          description: translations['breadCrumb.baskets_list'],
          routerLink: '/baskets-list'
        },
        {
          code: 'bc2',
          description: translations['breadCrumb.basketArticles'],
          routerLink: '/basket-articles'
        }
      ];

      this.showBreadCrumb = true;
    });
  }

  breadcrumbClicked(breadcrumb: BreadCrumbModel): void {
    if (breadcrumb && breadcrumb.routerLink) {
      this.router.navigate([breadcrumb.routerLink]);
    } else {
      console.warn('Breadcrumb senza routerLink');
    }
  }

  /* =======================
   * NAVIGATION
   * ======================= */
  goToArticle(row: any): void {
    if (!row || !row.id) {
      console.error('Articolo non valido:', row);
      return;
    }

    this.router.navigate(['/articles', row.id]);
  }

  /* =======================
   * ERROR HANDLING
   * ======================= */
  private showErrorMessage(message: string): void {
    this.notifyService.add({
      severity: 'error',
      summary: 'Errore',
      detail: message
    });
  }

   onGoBack(){
          this.router.navigate(['/basket-import-csv'], {
        queryParams: { basketId: this.basketId }
      });
  }
}


// WEBPACK FOOTER //
// ./src/app/views/baskets/basket-import-articles/basket-import-articles.component.ts